import React from "react";
import Dropzone from "react-dropzone";
import iconUpload from "./../../assets/images/icon_upload.png";

class FileUploadChannel extends React.Component {
  state = { warningMsg: "",
src: '',
accepted: '' };

logoUrlProcess = () => {
  if(this.props.logoAvailable){
    this.props.fileBaseValue(this.props.logourl)
  }
}

componentDidMount(){
  this.logoUrlProcess();
  console.log(this.props.logourl)
}

  onDrop = (accepted, rejected) => {
    if (Object.keys(rejected).length !== 0) {
      const message = "Please upload a Image file";  
      this.props.hasFileError(true); 
      this.setState({ warningMsg: message });
    } else {
      console.log(accepted[0])
      this.props.addFile(accepted);     
      this.setState({ warningMsg: "" });
      var blobPromise = new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(accepted[0]);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        };
      });
      blobPromise.then(value => {
        this.setState({
          src: value,
          accepted: accepted[0]
        })
        this.props.fileBaseValue(value,accepted[0]);
      });
    }
  };

  render() {
    const { files } = this.props;
    const render =
      Object.keys(files).length !== 0 ? ( 
        files.map(file => <p  className="hello" key={file.name} style={{textAlign: 'center', marginTop: '1%'}}>
        <img src={this.state.src} style={{height: '200px', width: '200px'}} /> 
         {/* <i class="fas fa-paperclip " aria-hidden="true"></i>  */}
        </p>)        
      ) : (
        <p style={{ textAlign: 'center'}}>     
        {this.props.logourl===undefined ? <React.Fragment>
        <img src={iconUpload} style={{height: '100px', width: '100px'}}/>
        <div style={{fontSize: '35px'}}> Channel Logo Image</div>
        <div style={{fontSize: '14px'}}> Drag & Drop</div>
        </React.Fragment> : <img src={this.props.logourl} style={{height: '200px', width: '200px'}} /> }
        </p>
      );
    return (
      <div style={{width: '100%'}}>     
        <Dropzone
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: '400px',
            // height: "50vh",
            // border: " 2px dashed"
          }}
          multiple={false}
          maxSize={5242880}       
          accept="image/jpg, image/png"
          onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
        >
          {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
            // if (isDragReject) return "Please submit a valid .pdf file(max size: 5MB)";
            if (isDragReject) return  <img src={iconUpload} style={{height: '15px', width: '15px'}}/>;
            return render;
          }}
        </Dropzone>
      </div>
    );
  }
}

export default FileUploadChannel;
